import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import ErrorBoundary from "./ErrorBoundary.jsx";
import { ToastProvider } from "./Ui/index.jsx";
import { startAnalytics } from "./Services/analytics.js";
import "./Styles/design-system.css";
import "./Styles/App.css";

startAnalytics();

// Older builds wrote every API answer into this browser database and never read or cleared it, so a shared computer kept
// the last person's data after logout. Nothing writes to it now; this deletes what is left. Remove after 2027-02-01.
try { indexedDB.deleteDatabase("IntranetCache"); } catch { /* no IndexedDB in this browser */ }

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <App />
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);